module.exports = __webpack_public_path__ + "img/02_bg.d5556324.jpg";